<div class="relative w-full" [attr.aria-label]="chartTitle || 'Transaction activity charts'">
  <div class="grid grid-cols-1 items-stretch gap-6 min-[901px]:grid-cols-[minmax(0,2fr)_minmax(260px,1fr)]">
    <div class="flex min-w-0 flex-col gap-2 overflow-hidden rounded-xl border border-border bg-card">
      <div class="flex items-center justify-between gap-3 border-b border-border px-4 py-4">
        <h3 class="m-0 text-xs font-extrabold tracking-widest text-fg uppercase">{{ chartTitle || 'Transaction Activity (Last 30 Days)' }}</h3>
        <div class="inline-flex flex-wrap items-center gap-3.5">
          <span class="inline-flex items-center gap-1 text-[0.58rem] font-extrabold tracking-wide text-muted uppercase"><span class="inline-block size-2 rounded-sm bg-primary"></span>Deposits</span>
          <span class="inline-flex items-center gap-1 text-[0.58rem] font-extrabold tracking-wide text-muted uppercase"><span class="inline-block size-2 rounded-sm bg-info"></span>Payouts</span>
        </div>
      </div>
      <div class="relative h-[305px] min-h-[260px] w-full p-3.5">
        <canvas #barCanvas class="max-h-full" role="img" [attr.aria-label]="(chartTitle || 'Transaction activity') + ' bar chart'"></canvas>
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-2 overflow-hidden rounded-xl border border-border bg-card">
      <div class="flex items-center justify-between gap-3 border-b border-border px-4 py-4">
        <h3 class="m-0 text-xs font-extrabold tracking-widest text-fg uppercase">By Transaction Type</h3>
      </div>
      @if (transactionTypes.length > 0 && hasPolarData()) {
        <div class="relative h-[305px] min-h-[260px] w-full p-3.5">
          <canvas #polarCanvas class="max-h-full" role="img" [attr.aria-label]="(chartTitle || 'Transaction activity') + ' polar chart'"></canvas>
        </div>
      } @else {
        <p class="m-0 p-4 text-center text-sm text-muted">No transaction type data for this period</p>
      }
    </div>
  </div>

  <div
    #externalTooltip
    class="pointer-events-none fixed z-10050 max-w-80 rounded-xl border border-border bg-card px-3.5 py-2.5 text-[0.8125rem] leading-snug text-fg opacity-0 shadow-lg transition-opacity duration-100"
    aria-hidden="true"
  ></div>
</div>
